<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("gastosPorEtiquetas")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="listProcedencia">{{$t("procedencia")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="procedencia"
                                           filterable
                                           @change="numFather=0,listFather=[],getGastosNegocio()"
                                           :placeholder="$t('seleccionaProcedencia')">
                                    <el-option
                                            class="select-primary"
                                            :value=2
                                            :label="$t('todos')"
                                            :key=2>
                                    </el-option>
                                    <el-option
                                            class="select-primary"
                                            :value=1
                                            :label="$t('deCaja')"
                                            :key=1>
                                    </el-option>
                                    <el-option
                                            class="select-primary"
                                            :value=0
                                            :label="$t('fueraDeCaja')"
                                            :key=0>
                                    </el-option>

                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getGastosNegocio()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">

                <div class="col-md-8">
                    <div class="col-md-12">
                        <h3 v-if="listNames.length>0">{{$t("desgloseDeGastos")}} <span class="text-primary">{{listNames[numFather-1]}}</span>
                        </h3>
                    </div>
                    <div class="col-md-3">
                        <button v-if="listNames.length>0" class="btn btn-primary"
                                @click="accionarChildrens(null,null,false)"><i
                                class="fas fa-arrow-circle-left"></i>
                            {{$t("volverA")}} <span v-if="listNames.length<2">{{$t("general")}}</span>
                            {{listNames[numFather-2]}}
                        </button>
                    </div>
                    <div class="col-md-12">
                        <template v-if="list.length>0">
                            <div class="row justify-content-between div-export">

                                <!--IMPORTAR-->
                                <!--<div class="col-md-2 col-xs-12 text-right">
                                    <el-dropdown>
                                        <el-button type="primary" size="small">
                                            <i class="fa fa-file"></i>
                                            {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <a :href="urlExportPDF">
                                                <el-dropdown-item class="text-danger">
                                                    <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                                </el-dropdown-item>
                                            </a>
                                            <a :href="urlExportExcel">
                                                <el-dropdown-item class="text-success">
                                                    <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                                </el-dropdown-item>
                                            </a>
                                        </el-dropdown-menu>
                                    </el-dropdown>

                                </div>-->
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered table-striped text-nowrap">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th>

                                          <span v-if="ordenarCategoria"
                                                @click="sortedArrayASC(1),ordenarCategoria=0"><i
                                                  style="color: white" class="fa fa-angle-up"></i> {{$t("categoria")}}
                                    </span>
                                            <span v-else @click="sortedArrayDESC(1), ordenarCategoria=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("categoria")}}
                                    </span>
                                        </th>
                                        <th>

                                        <span v-if="ordenarImporte"
                                              @click="sortedArrayASC(2),ordenarImporte=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                    </span>
                                            <span v-else @click="sortedArrayDESC(2), ordenarImporte=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                    </span>


                                        </th>
                                        <th width="5%">{{$t("acciones")}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="(obj,index) in list">
                                        <td>{{obj.name}}</td>
                                        <td class="text-right">{{obj.price | currency}} <span
                                                class="text-primary" v-if="getTotalPrecio!==0">({{Math.round(((obj.price/getTotalPrecio)*100)*100)/100}} %)</span>
                                        </td>
                                        <td align="center">
                                            <div class="btn btn-primary btn-link">
                                                <i
                                                    v-tooltip.top-center="$i18n.t('verDetallesDeGasto')"
                                                    style="cursor: pointer"
                                                    @click="openModal(obj)"
                                                    class="fas fa-list-ul text-primary"></i>
                                            </div>
                                            <div class="btn btn-primary btn-link">
                                                <i v-if="obj.childrens.length>0"
                                                                                     v-tooltip.top-center="$i18n.t('desgloseDeGastosPorEtiquetasHijas')"
                                                                                     style="cursor: pointer"
                                                                                     @click="accionarChildrens(index,obj,true)"
                                                                                     class="fas fa-arrow-circle-right"></i>
                                            </div>


                                        </td>
                                    </tr>

                                    </tbody>
                                    <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{$t("total")}}</strong></td>
                                        <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                        <td></td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </template>
                        <template v-else>
                            <!--<p><i class="fa fa-info-circle"></i>-->
                            <!--<small>-->
                            <!--{{$t("infoConsumo")}}-->
                            <!--</small>-->
                            <!--</p>-->
                            <div class="alert alert-danger" role="alert">
                                {{$t("noHay")}} <strong>{{$t("gastos")}}</strong> {{$t("rangoDeFechas")}}
                            </div>
                        </template>
                    </div>
                </div>

                <div class="col-md-4 " v-show="this.list.length > 0">
                    <div class="card">
                        <canvas id="chart"></canvas>


                    </div>
                </div>
            </template>
        </div>

        <modal name="modal-ver-ref" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("referencias")}} <span class="text-primary">{{objetoRef.name}}</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>

                                <th v-if="ordenRef===0" @click="sortedArrayRefASC()"><i
                                        style="color: white" class="fa fa-angle-up"></i>
                                    {{$t("referencia")}}
                                </th>
                                <th v-else @click="sortedArrayRefDESC()"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("referencia")}}
                                </th>
                                <th v-if="ordenNameProveedor===0" @click="sortedArrayNameSupplierASC()"><i
                                        style="color: white" class="fa fa-angle-up"></i>
                                    {{$t("nombreProveedor")}}
                                </th>
                                <th v-else @click="sortedArrayNameSupplierDESC()"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("nombreProveedor")}}
                                </th>
                                <th v-if="ordenImport===0" @click="sortedArrayPriceASC()"><i
                                        style="color: white" class="fa fa-angle-up"></i>
                                    {{$t("importe")}}
                                </th>
                                <th v-else @click="sortedArrayPriceDESC()"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="ref in objetoRef.ref">
                                <td>{{ref.ref}}</td>
                                <td>{{ref.nameSupplier}}</td>
                                <td align="right">{{ref.price | currency}}</td>
                            </tr>


                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td></td>
                                <td class="text-right"><strong>{{getTotalPrecioRef | currency}}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>


                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">
                        <button @click="cerrarModal()" class="btn btn-danger"><i class="fas fa-arrow-circle-left"></i>
                            {{$t("volver")}}
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", this.$i18n.t('gastosPorEtiquetas'));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                mode: 0,
                procedencia: 2,
                $Chart: null,
                objectChart: null,
                contador: 0,

                listFather: [],
                numFather: 0,
                listNames: [],

                objetoRef: 0,


                //ORDENAR MODAL
                ordenRef: 0,
                ordenImport: 0,
                ordenNameProveedor: 0,

                //ORDENAR
                ordenarCategoria: 0,
                ordenarImporte: 0,

                respuesta: true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {

                return this.$store.getters.apiUrl + "/suppliers/exportGastosSupplier/PDF?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&mode=" + this.mode + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {

                return this.$store.getters.apiUrl + "/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },

            getTotalPrecioRef() {

                var total = 0;


                if (this.objetoRef !== 0) {
                    this.objetoRef.ref.forEach(function (d) {

                        total += d.price;

                    });
                }

                return total;
            },

            getTotalPrecio() {

                var total = 0;


                this.list.forEach(function (d) {

                    total += d.price;

                });

                return total;

            }
        },
        methods: {

            sortedArrayASC: function (nameAtributo) {


                switch (nameAtributo) {

                    case 1:

                        this.ordenarCategoria = 1;

                    function compareCategoria(a, b) {

                        if (a.name.toUpperCase() < b.name.toUpperCase())
                            return -1;
                        if (a.name.toUpperCase() > b.name.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.list.sort(compareCategoria);

                    case 2:

                        this.ordenarImporte = 1;

                    function comparePrice(a, b) {

                        if (a.price < b.price)
                            return -1;
                        if (a.price > b.price)
                            return 1;
                        return 0;
                    }

                        return this.list.sort(comparePrice);

                }

            },
            sortedArrayDESC: function (nameAtributo) {


                switch (nameAtributo) {

                    case 1:

                        this.ordenarCategoria = 0;

                    function compareCategoria(a, b) {

                        if (a.name.toUpperCase() > b.name.toUpperCase())
                            return -1;
                        if (a.name.toUpperCase() < b.name.toUpperCase())
                            return 1;
                        return 0;
                    }

                        return this.list.sort(compareCategoria);

                    case 2:

                        this.ordenarImporte = 0;

                    function comparePrice(a, b) {

                        if (a.price > b.price)
                            return -1;
                        if (a.price < b.price)
                            return 1;
                        return 0;
                    }

                        return this.list.sort(comparePrice);

                }

            },

            sortedArrayRefASC: function () {
                this.ordenRef = 1;

                function compare(a, b) {
                    if (a.ref < b.ref)
                        return -1;
                    if (a.ref > b.ref)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },
            sortedArrayRefDESC: function () {
                this.ordenRef = 0;

                function compare(a, b) {

                    if (a.ref > b.ref)
                        return -1;
                    if (a.ref < b.ref)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },

            sortedArrayNameSupplierASC: function () {
                this.ordenNameProveedor = 1;

                function compare(a, b) {
                    if (a.nameSupplier < b.nameSupplier)
                        return -1;
                    if (a.nameSupplier > b.nameSupplier)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },
            sortedArrayNameSupplierDESC: function () {
                this.ordenNameProveedor = 0;

                function compare(a, b) {

                    if (a.nameSupplier > b.nameSupplier)
                        return -1;
                    if (a.nameSupplier < b.nameSupplier)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },
            sortedArrayPriceASC: function () {
                this.ordenImport = 1;

                function compare(a, b) {
                    if (a.price < b.price)
                        return -1;
                    if (a.price > b.price)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },
            sortedArrayPriceDESC: function () {
                this.ordenImport = 0;

                function compare(a, b) {

                    if (a.price > b.price)
                        return -1;
                    if (a.price < b.price)
                        return 1;
                    return 0;
                }

                return this.objetoRef.ref.sort(compare);
            },

            openModal(obj) {
                this.$modal.show("modal-ver-ref");

                this.objetoRef = obj;


            },
            cerrarModal() {

                this.$modal.hide("modal-ver-ref");

            },

            sortedArrayPriceEtiquetasASC: function () {
                function compare(a, b) {

                    if (a.price > b.price)
                        return -1;
                    if (a.price < b.price)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            cambioNegocio() {
                this.procedencia = 2;
                this.getGastosNegocio();

            },

            accionarChildrens(index, obj, hijo) {


                if (hijo) {
                    this.listFather.push(this.list);

                    this.numFather++;

                    this.list = obj.childrens;


                    if (obj.price - this.getTotalPrecio !== 0) {

                        let xDate = {
                            name: obj.name,
                            price: obj.price - this.getTotalPrecio,
                            childrens: [],
                            ref: obj.ref,
                            parentCode: 0

                        };
                        this.list.push(xDate);

                    }


                    this.listNames.push(obj.name);


                    this.sortedArrayPriceEtiquetasASC();
                } else {

                    // Evitar decrementar por debajo de 0 y restaurar de forma segura
                    if (this.numFather <= 0) {
                        this.numFather = 0;
                        this.listNames = [];
                        this.list = this.listFather[0] || [];
                        this.sortedArrayPriceEtiquetasASC();
                        this.initChart();
                        return;
                    }

                    this.numFather--;
                    this.listNames.splice(this.numFather, 1);
                    this.list = this.listFather[this.numFather] || [];

                    this.sortedArrayPriceEtiquetasASC();

                }

                this.initChart();
            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getGastosNegocio();


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getGastosNegocio() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {


                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;


                        this.numFather = 0;
                        this.listFather = [];
                        this.listNames = [];

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                mode: this.mode,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                procedencia: this.procedencia,
                                idSupplier: 0,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "sales/getGastosTags", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.respuesta = true;
                                    vm.list = response.data.result;
                                    vm.sortedArrayPriceEtiquetasASC();

                                    vm.initChart()
                                } else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;
                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },


            initChart() {


                let labels = this.list.map(function (x) {
                    return x.name;
                });


                let data = this.list.map(function (x) {
                    return x.price;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: true,
                                    position: 'bottom',

                                }
                            }
                        });


                        this.contador++;
                    }
                } else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart("chart", {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: true,
                                position: 'bottom'
                            }
                        }
                    });

                }
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Proveedores/GastosPorEtiqueta.vue